import avatar1 from '../../../../assets/images/lg/avatar1.jpg';
import avatar2 from '../../../../assets/images/lg/avatar2.jpg';
import avatar3 from '../../../../assets/images/lg/avatar3.jpg';
import avatar4 from '../../../../assets/images/lg/avatar4.jpg';
import avatar5 from '../../../../assets/images/lg/avatar5.jpg';
import avatar6 from '../../../../assets/images/lg/avatar6.jpg';

export const upcomingBirthdayData = [
    {
        profileImg: avatar1,
        name:'Natalie Gibson',
        position:'Master Safe',
        date:'12 Aug, 11:30AM'
    },
    {
        profileImg: avatar2,
        name:'Peter Piperg',
        position:'Sous Chef',
        date:'12 Aug, 11:30AM'
    },
    {
        profileImg: avatar3,
        name:'Robert Young',
        position:'Housekeeping Staff',
        date:'12 Aug, 11:30AM'
    },
    {
        profileImg: avatar4,
        name:'Gibson Butler',
        position:'Spa Manager',
        date:'12 Aug, 11:30AM'
    },
    {
        profileImg: avatar5,
        name:'Meta Rull',
        position:'Manager',
        date:'22 Aug, 11:30AM'
    },
    {
        profileImg: avatar6,
        name:'Rull Depo',
        position:'Bar',
        date:'15Aug, 10:30AM'
    },
]

export const empAvailabilityData = [
    {
        svgIcon:
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" strokeWidth="1" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <path d="M9 11l3 3l8 -8"></path>
            <path d="M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9"></path>
        </svg>,
        text: 'Attendance',
        count: '400'
    },
    {
        svgIcon:
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" strokeWidth="1" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
            <path d="M12 12l-2 -3"></path>
            <path d="M12 7v5"></path>
        </svg>,
        text: 'Late Coming',
        count: '17'
    },
    {
        svgIcon:
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" strokeWidth="1" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
            <path d="M5.7 5.7l12.6 12.6"></path>
        </svg>,
        text: 'Absent',
        count: '06'
    },
    {
        svgIcon:
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" strokeWidth="1" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <path d="M17.553 16.75a7.5 7.5 0 0 0 -10.606 0"></path>
            <path d="M18 3.804a6 6 0 0 0 -8.196 2.196l10.392 6a6 6 0 0 0 -2.196 -8.196z"></path>
            <path d="M16.732 10c1.658 -2.87 2.225 -5.644 1.268 -6.196c-.957 -.552 -3.075 1.326 -4.732 4.196"></path>
            <path d="M15 9l-3 5.196"></path>
            <path d="M3 19.25a2.4 2.4 0 0 1 1 -.25a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 1 .25"></path>
        </svg>,
        text: 'Leave Apply',
        count: '14'
    },
]